export var SET_LANG = 'SET_LANG';
export function setLanguageData(lang, data) {
    return function (dispatch) {
        dispatch({
            type: SET_LANG,
            payload: {
                lang: lang,
                data: data,
            },
        });
    };
}



//////////////////
// WEBPACK FOOTER
// ./src/auth/store/actions/lang.actions.ts
// module id = 353
// module chunks = 81